class ModelAbstract {
    constructor({
        id = null,
        createdAt = null,
        updatedAt = null,
    } = {}) {
        this.id = id;
        this.createdAt = createdAt ? new Date(createdAt) : new Date();
        this.updatedAt = updatedAt ? new Date(updatedAt) : new Date();
    }

    static fromAPI(data) {
        if (!data) return null;
        return new this({
            id: data.id,
            createdAt: data.createdAt,
            updatedAt: data.updatedAt,
        });
    }

    toJSON() {
        return {
            id: this.id,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
        };  
    }
}

export default ModelAbstract;